import React from 'react';
import { Button, Modal } from 'antd';
import { mainAxios } from '../middleware/interceptor';
import { toast } from 'react-toastify';

function DeleteSubCategoryModal({ visible, setVisible, deleteSubCategory, updateCountSheet }) {

  const handleDeleteConfirm = () => {
    setVisible(false);
    const payload = {
      "RestId": parseInt(localStorage.getItem('RestId')),
      "CatId": deleteSubCategory.CatId,
      "CatName": deleteSubCategory.CatName,
      "CountSheetId": deleteSubCategory.countSheetId,
      "subProductId": "",
      "SubCategoryId": deleteSubCategory.GroupedItems[deleteSubCategory.index].SubCategoryId
    }

    mainAxios.post(`api/Inventory/removeItemFromCountSheet`, payload).then((res) => {
      if (res?.data?.status == "1") {
        toast.success('SubCategory deleted successfully');
        updateCountSheet(deleteSubCategory.countSheetId);
      } else {
        toast.warning('Failed to delete a subcategory');
      }
    }).catch((err) => { console.log(err) });
  };

  return (
    <Modal
      title='Delete'
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      footer={[
        <Button
          onClick={() => setVisible(false)}
          className='Deactivate-Button'
        >
          Cancel
        </Button>,
        <Button
          onClick={handleDeleteConfirm}
        >
          Confirm
        </Button>
      ]}
    >
      <div>Are you sure want delete?</div>
    </Modal>
  )
}

export default DeleteSubCategoryModal;
